import { fade, makeStyles } from '@material-ui/core/styles'

/** One column constant for header, row and skeleton (§2). */
const COLUMNS = '4fr 5fr 8fr 5fr 5fr 4fr 1fr'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    // Grid children default to min-width:auto, which means a long unbreakable
    // string sets the column's floor and pushes every other column aside — one
    // encoded identifier was enough to wreck the whole row. min-width:0 lets the
    // track shrink to its fr share, and overflow-wrap breaks the token inside its
    // own cell instead of outside it.
    '& > div': {
      minWidth: 0,
      overflowWrap: 'anywhere',
      // A cell holding a Chip beside text: Chip is inline-flex, Typography
      // renders a block <p>, so without flex the text drops to a second line
      // and that row alone is two lines tall. Visible in the reported
      // screenshot as "Needs Adotel" sitting above "Unassigned".
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 4
    },
    width: '100%',
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableRow: {
    // Grid children default to min-width:auto, which means a long unbreakable
    // string sets the column's floor and pushes every other column aside — one
    // encoded identifier was enough to wreck the whole row. min-width:0 lets the
    // track shrink to its fr share, and overflow-wrap breaks the token inside its
    // own cell instead of outside it.
    '& > div': {
      minWidth: 0,
      overflowWrap: 'anywhere',
      // A cell holding a Chip beside text: Chip is inline-flex, Typography
      // renders a block <p>, so without flex the text drops to a second line
      // and that row alone is two lines tall. Visible in the reported
      // screenshot as "Needs Adotel" sitting above "Unassigned".
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 4
    },
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    minHeight: 72,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    // No `cursor: pointer`: only the ticket number is a link, so a pointer
    // across the full row width promises a click target that does not exist.
    // The mobile card IS fully clickable; the desktop row is not.
    paddingLeft: 12,
    marginBottom: 4,
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': { backgroundColor: theme.palette.background.paper }
  },
  // Redundant with the "Needs Adotel" chip in the same row on purpose: the
  // colour is a scanning aid, the chip is the meaning. Neither carries it alone.
  // Two lines keeps most titles whole while pinning row height. Not one line:
  // the title is the primary identifying content and would truncate too often.
  // The full title is always one click away — the number is a link to detail.
  titleCell: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },
  needsAttentionRow: {
    backgroundColor: fade(theme.palette.warning.main, 0.12)
  },
  refreshButtonContainer: { display: 'flex', justifyContent: 'flex-end' },
  skeleton: { marginInlineEnd: theme.spacing(2) },
  noDataImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4)
  },
  mobileList: { padding: theme.spacing(0.5, 1.5) },
  mobileEmpty: {
    textAlign: 'center',
    padding: theme.spacing(3),
    color: theme.palette.text.secondary
  },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2)
  }
}))

export default useStyles
